const ApiConfig = {
  baseURL: process.env.REACT_APP_SERVER_API_URL,
  network: process.env.REACT_APP_NETWORK || 'main',
  resourceURL: process.env.REACT_APP_SERVER_RESOURCE_URL
}

export default ApiConfig
